import React, { useState, useEffect } from "react";
import { Container, Row, Col, Carousel, Button } from "react-bootstrap";
import API_BASE from "../config/api";
import { resolveImageUrl } from "../utils/siteHelpers";

// Fallback defaults — only used if the Admin Panel hasn't set anything yet,
// or if the homepage-ads API call fails, so the homepage never breaks.
const DEFAULT_BIG = [
    { img: "/assets/1.png", btn: "Call Now", link: "" },
    { img: "/assets/2.png", btn: "Book Now", link: "" },
    { img: "/assets/3.png", btn: "Call Now", link: "" },
];
const DEFAULT_RIGHT = [
    { img: "/assets/R1.png", btn: "Call Now", link: "" },
    { img: "/assets/R2.png", btn: "Book Now", link: "" },
    { img: "/assets/R3.png", btn: "Call Now", link: "" },
    { img: "/assets/R4.png", btn: "Book Now", link: "" },
];

export default function AdsSection() {
    const [index, setIndex] = useState(0);
    const [bigSlides, setBigSlides] = useState(DEFAULT_BIG);
    const [rightCards, setRightCards] = useState(DEFAULT_RIGHT);

    // CR: "Dynamic landing page images" — these used to be hard-coded here;
    // now they're pulled from the Admin Panel (see AdminHomepageImages.jsx).
    useEffect(() => {
        fetch(`${API_BASE}/api/get_homepage_ads.php`)
            .then((r) => r.json())
            .then((data) => {
                if (data.success) {
                    if (data.bigSlides?.length) setBigSlides(data.bigSlides);
                    if (data.rightCards?.length) setRightCards(data.rightCards);
                }
            })
            .catch(() => { /* keep defaults on failure */ });
    }, []);

    // Homepage-ad images uploaded through the Admin Panel are stored as
    // backend-relative paths (e.g. "uploads/business/homepage_ad/xxx.png");
    // the bundled /assets/*.png defaults are already absolute frontend
    // paths and must be left alone.
    const resolveAdImg = (src) => (src && !src.startsWith("/assets/") ? resolveImageUrl(API_BASE, src) : src);

    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };

    return (
        <>
            {/* 🔥 FORCE WHITE TEXT STYLE */}
            <style>{`
        .ads-slider-btn {
          background-color: #0076d7 !important;
          color: #ffffff !important;
          border: none !important;
        }
        .ads-slider-btn:hover {
          background-color: #005bb5 !important;
          color: #ffffff !important;
        }
      `}</style>

            <section className="my-3 mt-1">
                <Container>
                    <Row className="g-4">

                        {/* LEFT SIDE BIG SLIDER */}
                        <Col md={7}>
                            <Carousel
                                activeIndex={index}
                                onSelect={handleSelect}
                                interval={1500}
                                fade
                                controls
                                indicators
                            >
                                {bigSlides.map((slide, idx) => (
                                    <Carousel.Item key={idx}>
                                        <div
                                            className="rounded shadow-sm position-relative w-100"
                                            style={{
                                                aspectRatio: "16 / 7",
                                                borderRadius: "6px",
                                                overflow: "hidden",
                                            }}
                                        >
                                            <img
                                                src={resolveAdImg(slide.img)}
                                                alt="slide"
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                }}
                                            />

                                            <Button
                                                className="ads-slider-btn px-4 py-2 fw-semibold"
                                                href={slide.link || undefined}
                                                target={slide.link ? "_blank" : undefined}
                                                rel={slide.link ? "noopener noreferrer" : undefined}
                                                style={{
                                                    position: "absolute",
                                                    left: "15px",
                                                    bottom: "15px",
                                                    borderRadius: "4px",
                                                }}
                                            >
                                                {slide.btn}
                                            </Button>
                                        </div>

                                    </Carousel.Item>
                                ))}
                            </Carousel>
                        </Col>

                        {/* RIGHT SIDE CARDS */}
                        <Col md={5}>
                            <Row className="g-4">
                                {rightCards.map((item, idx) => (
                                    <Col xs={12} sm={6} key={idx}>
                                        <div
                                            className="position-relative shadow-sm w-100"
                                            style={{
                                                borderRadius: "6px",
                                                overflow: "hidden",
                                                aspectRatio: "16/9.6",
                                            }}
                                        >
                                            <img
                                                src={resolveAdImg(item.img)}
                                                alt="promo"
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                }}
                                            />

                                            {/* ✅ FIXED SMALL BUTTON */}
                                            <Button
                                                size="sm"
                                                className="ads-slider-btn fw-semibold"
                                                href={item.link || undefined}
                                                target={item.link ? "_blank" : undefined}
                                                rel={item.link ? "noopener noreferrer" : undefined}
                                                style={{
                                                    position: "absolute",
                                                    left: "10px",
                                                    bottom: "10px",
                                                    borderRadius: "4px",
                                                    padding: "4px 12px",
                                                    fontSize: "0.8rem",
                                                }}
                                            >
                                                {item.btn}
                                            </Button>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </Col>

                    </Row>
                </Container>
            </section>
        </>
    );
}
